import { ResourceProvider } from "../../providers/resource.provider"
import { BOGPayment, PaymentMethod, TBCBnpl } from "./PaymentMethod"
import { BOGPaymentSerializer, PaymentMethodSerializer, TBCBnplSerialzer } from "./serializer"


export class PaymentMethodProvider extends ResourceProvider<PaymentMethod> {
    constructor() {
        super("rest_payment_method", new PaymentMethodSerializer())
    }
}
export class BOGPaymentProvider extends ResourceProvider<BOGPayment> {
    constructor() {
        super("rest_bog_payment", new BOGPaymentSerializer())
    }
}
export class BOGWalletPaymentProvider extends ResourceProvider<BOGPayment> {
    constructor() {
        super("rest_bog_wallet_payment", new BOGPaymentSerializer())
    }
}
export class BOGApplePayPaymentProvider extends ResourceProvider<BOGPayment> {
    constructor() {
        super("rest_bog_apple_pay_payment", new BOGPaymentSerializer())
    }
}
export class TBCBnplProvider extends ResourceProvider<TBCBnpl> {
    constructor() {
        super("rest_tbc_bnpl_payment", new TBCBnplSerialzer())
    }
}

export const paymentMethodService = new PaymentMethodProvider()
export const bogPaymentService = new BOGPaymentProvider()
export const bogWalletPaymentService = new BOGWalletPaymentProvider()
export const bogApplePayPaymentService = new BOGApplePayPaymentProvider()
export const tbcBnplService = new TBCBnplProvider()
